module.exports = __webpack_public_path__ + "img/img-event-m-tab-041.e56ad8d9.png";